import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../../../utils";

export const ItemsContainer = styled.div<{ isGI?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media ${deviceType.mobile} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${(props) => (props.isGI ? "16px" : "12px")};
    ${(props) =>
      props.isGI &&
      `
      & > *:nth-child(even) {
        justify-content: flex-end;
      }
    `}
  }
`;

export const ItemButton = styled.button<{
  isDisabled: boolean;
  isGI?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 16px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: ${(props) => (props.isDisabled ? "default" : "pointer")};
  opacity: ${(props) => (props.isDisabled ? 0.45 : 1)};
  pointer-events: ${(props) => (props.isDisabled ? "none" : "auto")};
  width: 100%;
  text-align: left;

  /* Desktop styles */
  font-family: Lato;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  color: ${(props) => (props.isDisabled ? theme.greyText4 : theme.blueText)};
  img,
  svg {
    width: 100%;
    height: 100%;
    display: block;
    ${(props) =>
      props.disabled &&
      `
      filter: grayscale(100%);
      opacity: 0.90;
    `}
  }

  /* Mobile styles - override desktop styles */
  @media ${deviceType.mobile} {
    ${(props) =>
      props.isGI
        ? `
      background: transparent;
      border: none;
      border-radius: 0;
      padding: 0;
      gap: 5px;
      font-weight: 400;
      font-size: 14px;
      text-align: left;
      height: auto;
      justify-content: flex-start;
      color: ${props.isDisabled ? theme.greyText4 : "#2276E3"};
    `
        : `
      height: 32px;
      align-items: center;
      justify-content: center;
      padding: 12px 16px;
      border-radius: 8px;
      background: ${props.isDisabled ? theme.greyText2 : theme.whiteText};
      border: ${props.isDisabled ? "none" : `1px solid ${theme.blueText}`};
      gap: 4px;
      font-weight: 900;
      font-size: 12px;
      text-align: center;
      color: ${props.isDisabled ? theme.lightBlack : theme.blueText};
    `}
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
  }
`;

export const ButtonIcon = styled.div<{
  isDisabled: boolean;
}>`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  img,
  svg {
    width: 100%;
    height: 100%;
    display: block;
    ${(props) =>
      props.isDisabled &&
      `
      filter: grayscale(100%);
      opacity: 0.90;
    `}
  }
`;

export const ButtonText = styled.span`
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  color: inherit;
  white-space: nowrap;

  @media ${deviceType.mobile} {
    white-space: nowrap;
  }
`;

export const ContentWrapper = styled.div.attrs({
  "data-insurance-content": true,
})`
  padding: 20px;
  @media ${deviceType.mobile} {
    padding: 16px;
  }
`;
